import { render, staticRenderFns } from "./DatePickerOnlyYear.vue?vue&type=template&id=4fb53539"
import script from "./DatePickerOnlyYear.vue?vue&type=script&lang=js"
export * from "./DatePickerOnlyYear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports